// /src/utils/checkLessonAccess.js
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const units = [
  { unitId: 1, lessons: [1, 2, 3, 4] },
  { unitId: 2, lessons: [5, 6, 7, 8] },
  { unitId: 3, lessons: [9, 10, 11, 12, 13] },
  { unitId: 4, lessons: [14, 15, 16, 17, 18, 19] },
  { unitId: 5, lessons: [20, 21, 22, 23, 24] },
  { unitId: 6, lessons: [25, 26, 27, 28, 29, 30, 31] },
  { unitId: 7, lessons: [32, 33, 34, 35] },
  { unitId: 8, lessons: [36, 37, 38, 39, 40] },
];

export const checkLessonAccess = async (lessonNum) => {
  const user = auth.currentUser;
  if (!user) return false;

  const userDoc = await getDoc(doc(db, 'users', user.uid));
  const userProgress = userDoc.data().lessons || {};

  const unit = units.find((u) => u.lessons.includes(lessonNum));
  if (!unit) return false;

  const unitLessons = unit.lessons;
  const index = unitLessons.indexOf(lessonNum);

  if (index === 0) return true; // First lesson in the unit is always unlocked

  const prevLesson = unitLessons[index - 1];
  return !!userProgress[`lesson${prevLesson}`];
};
